export const DEFAULT_GALLERY_IMAGES = [
  {
    "id": "3Qv0NWmvmNGbMdrrH3B5",
    "title": "Aménagement intérieur & finitions à La Teste-de-Buch",
    "description": "Confiez la rénovation et l'aménagement intérieur de vos pièces à nos artisans experts sur le Bassin d'Arcachon. Finitions impeccables !",
    "url": "/gallery_defaults/gallery-1.jpg",
    "alt": "Finitions des joints de plâtre autour d'une porte lors d'une rénovation d'un bureau à Gujan-Mestras."
  },
  {
    "id": "4TTA4Vq3kE3HZ2rVGL64",
    "title": "Finitions de plâtrerie et aménagement au Teich",
    "description": "Confiez la rénovation et les finitions de vos espaces à Parat & Bouey, vos artisans experts en aménagement intérieur sur le Bassin d'Arcachon.",
    "url": "/gallery_defaults/gallery-2.jpg",
    "alt": "Finitions soignées sur un muret d'escalier en plâtre lors d'un aménagement intérieur à La Teste-de-Buch."
  },
  {
    "id": "AuxC7ulshwQvwUT68R0p",
    "title": "Plâtrerie moderne et faux plafond LED",
    "description": "Sublimez votre intérieur avec un faux plafond à gorge lumineuse LED et des finitions soignées sur le Bassin.",
    "url": "/gallery_defaults/gallery-3.jpg",
    "alt": "Faux plafond LED et travaux de plâtrerie par un plaquiste au Bassin d'Arcachon"
  },
  {
    "id": "InrYC3lWJk5RXMArFqN3",
    "title": "Rénovation & Aménagement Intérieur à Arcachon",
    "description": "Sublimer votre intérieur avec des travaux de rénovation sur mesure. Création d'arches et finitions soignées par nos artisans à La Teste-de-Buch.",
    "url": "/gallery_defaults/gallery-4.jpg",
    "alt": "Rénovation d'intérieur avec arche en plâtre et éclairage indirect LED réalisée par un artisan à La Teste-de-Buch."
  },
  {
    "id": "Y345MFM2xiyWrSnAZEd2",
    "title": "Travaux d'isolation intérieure sur le Bassin d'Arcachon",
    "description": "Confiez la rénovation et l'aménagement intérieur de votre maison à nos artisans qualifiés à Gujan-Mestras. Isolation thermique performante.",
    "url": "/gallery_defaults/gallery-5.jpg",
    "alt": "Pose de laine d'isolation et ossature métallique sur un mur avec fenêtre lors de travaux à La Teste-de-Buch."
  },
  {
    "id": "qcl3fXxxxVrXFHmvkIuN",
    "title": "Jointoiement placo sur le Bassin d'Arcachon",
    "description": "Réalisation des joints de plaques de plâtre dans une pièce de vie lumineuse. Un travail soigné pour des finitions lisses avant peinture.",
    "url": "/gallery_defaults/gallery-6.jpg",
    "alt": "Pose de plaques de plâtre et bandes à joint par un plaquiste au Bassin d'Arcachon."
  }
];

export const DEFAULT_BEFORE_AFTER_ITEMS = [
  {
    "id": "5tc6FIfIEvC1ms4L5MQW",
    "title": "Transformation d'un garage en bureau ",
    "description": "Rénovation complète placo et isolation",
    "beforeUrl": "/gallery_defaults/ba-before-1.webp",
    "afterUrl": "/gallery_defaults/ba-after-1.webp"
  }
];
